import React, { useEffect, useRef } from 'react';
import { useWindowSize } from 'usehooks-ts';

import CorporateSubscription from '@components/pages/SubscriptionLanding/CorporateSubscription';
import useEventTracking from '@hooks/useEventTracking';
import { Page } from '@tracking';
import { generateCardProps, planType } from '@utils/subscriptionCardOptions';

import BestInTech from './BestInTech';
import HighlightedOffer from './HighlightedOffer';
import Offers from './Offers';
import Testimonials from './Testimonials';

interface ContentProps {
  highlightedOffer: planType;
  offerPlans: planType[];
}

const Content = ({ highlightedOffer, offerPlans }: ContentProps) => {
  const { width } = useWindowSize();
  const parentWrapper = useRef<HTMLDivElement>(null);
  const childWrapper = useRef<HTMLDivElement>(null);
  const page = highlightedOffer === 'yp' ? Page.YoungProfessionals : Page.SubscribeNow;
  const { Track } = useEventTracking({ page });

  useEffect(() => {
    if (parentWrapper.current && childWrapper.current) {
      // Set the parent's height to match the child's height
      parentWrapper.current.style.height = `${childWrapper.current.offsetHeight}px`;
    }
  }, [width]);

  return (
    <Track>
      <div ref={parentWrapper} className="relative bg-grayscale-charcoal">
        <HighlightedOffer
          childWrapper={childWrapper}
          offer={generateCardProps({ planType: highlightedOffer })}
        />
      </div>
      <div className="px-24 sm:px-28">
        <aside className="m-auto mt-80 max-w-[1070px] sm:mt-96">
          <Offers offerPlans={offerPlans} />
          <CorporateSubscription />
          <BestInTech />
          <Testimonials />
        </aside>
      </div>
    </Track>
  );
};

export default Content;
